import { computed, watch, type Ref, type WritableComputedRef } from 'vue'

interface SpaceSizeForm {
  living_space_size: number | null
  business_space_size: number | null
}

export function usePropertySpaceSize(
  form: SpaceSizeForm,
  hasLivingSpace: Ref<boolean>,
): WritableComputedRef<number | null> {
  watch(hasLivingSpace, (livingSpace) => {
    if (livingSpace) {
      form.business_space_size = null
    } else {
      form.living_space_size = null
    }
  })

  return computed({
    get: () => (hasLivingSpace.value ? form.living_space_size : form.business_space_size),
    set: (value) => {
      if (hasLivingSpace.value) {
        form.living_space_size = value
      } else {
        form.business_space_size = value
      }
    },
  })
}
